import React from "react";
import { Flex } from "components";
import { Pro } from "./LegacyLogo.styled";

const LegacyLogo = ({ kind, logoSize, gap, ...rest }) => {
  return (
    <Flex>
      <div>
        <img width={logoSize ?? 135} src="/legacy-main-logo.svg" alt="Legacy Logo" />
      </div>
      <Pro>PRO</Pro>
    </Flex>
  );
};

export default LegacyLogo;
